import { InputLabelHeight } from "@covertree/types";
import type { Theme } from "@mui/material/styles";

export const getInputLabelHeight = (theme: Theme, type: InputLabelHeight) => {
  if (type === InputLabelHeight.SMALL) return "auto";
  if (type === InputLabelHeight.DEFAULT) return theme.spacing(6);
  return "auto";
};

export default getInputLabelHeight;
